import { Autocomplete, InputAdornment, Popper, TextField, Tooltip, tooltipClasses } from "@mui/material";
import { styled } from "@mui/styles";


export const FormContainer = styled(Autocomplete)(({ islabelvisible }) => ({
    "& label": {
        fontSize: 14,
        color: "#2c2f44",
        fontFamily: 'Roboto, sans-serif',
        textTransform: "inherit",
    },
    "& label.MuiInputLabel-shrink": {
        fontSize: "1rem",
        backgroundColor: "white",
    },
    "& label.Mui-focused": {
        color: "#638dff",
    },
    "& .MuiSvgIcon-root": {
        color: "#638dff !important",
    },
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            borderColor: "#c4d8ff",
        },
        "&:hover fieldset": {
            borderColor: "#92afff",
        },
        "&.Mui-disabled": {
            backgroundColor: "#f4f7fb !important",
            "& fieldset": {
                borderColor: "#c4d8ff",
            },
        },
        "&.Mui-error": {
            "& fieldset": {
                borderColor: "#f2a29d !important",
            },
        },
        "&.Mui-focused fieldset": {
            borderColor: "#638dff",
        },
        "& .MuiOutlinedInput-input.Mui-disabled": {
            color: "#44485a",
            "WebkitTextFillColor": "#44485a",
        },
        "& .MuiAutocomplete-input": {
            ...(islabelvisible && {
                minWidth: "65px !important",
            }),
        },
        fontSize: 14,
        borderRadius: 6,
        fontFamily: 'Roboto, sans-serif',
        paddingRight: "9px !important",
        ...(islabelvisible && {
            width: "max-content",
            paddingRight: "9px !important",
        }),
    },
    "& .MuiAutocomplete-noOptions": {
        padding: "10px 15px",
        fontSize: "14px",
        color: "#888",
        fontFamily: 'Roboto, sans-serif',
    },
}));

export const TextFieldContainer = styled(TextField)(() => ({
    "& .MuiInputLabel-asterisk": {
        color: "#e5453b",
    },
    "& .MuiFormHelperText-root": {
        color: "#e5453b !important",
    },
}));

export const InputAdornmentContainer = styled(InputAdornment)(() => ({
    opacity: 0.7,
    cursor: "pointer",
}));

export const Info = styled(Tooltip)(() => ({
    right: 5,
}));

export const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: "rgba(0, 0, 0, 0.75)",
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        borderRadius: 3,
    },
}));

export const ProperContainer = styled(Popper)(() => ({
    "& .MuiAutocomplete-paper": {
        marginTop: "4px",
        boxShadow: "0 0 10px 0 rgb(152 176 200 / 40%)",
        borderRadius: 6,
    },
    "& .MuiAutocomplete-option.Mui-focused": {
        backgroundColor: "rgba(99, 141, 255, 0.1) !important",
    },
    "& .MuiAutocomplete-option": {
        paddingRight: "7px !important",
    },
}));

export const LookUpDropCustom = styled("div")(() => ({
    display: "flex !important",
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between !important",
    padding: "10px 15px",
    "& span": {
        fontSize: 14,
        color: "#44485a",
    },
}));